import { api } from './api';

export const authService = {
  login: async ({ email, password }) =>
    api.post('/auth/login', { email: email.trim().toLowerCase(), password }, { auth: false }),

  employeeLogin: async ({ tema_api_key, tema_user_id, name, email, phone, rso }) =>
    api.post('/auth/tema/employee-login', { tema_api_key, tema_user_id, name, email, phone, rso }, { auth: false }),

  logout: async () => api.get('/auth/logout'),

  getProfile: async () => api.get('/auth/profile'),
};
